<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div class="">
      <!-- title above form card -->
      <h1 class="px-4 fade-in-up-enter-active animation-slowest max-100 text-primary">Subsidiepercentage</h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Extra subsidie voor lage inkomens</h5>
      <div class="d-flex flex-column flex-lg-row justify-content-center">

        <!-- form 1 card -->
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">
            <div>
              <h6 class="pb-3 mt-3 max-100">{{ lead.property.InVersterkingsprogramma ? '100% van de kosten tot &euro;40.000 vergoed' : '50% of 100% vergoeding voor kosten tot &euro;40.000' }}</h6>
              <div class="small mb-4">
                  <div v-if="!lead.property.InVersterkingsprogramma">
                    <checkmark-item class="mb-2" icon="info-circle-fill">
                      Huishoudens met een inkomen <strong class="fw-600">tot 140% van het sociaal minimum</strong> krijgen <strong class="fw-600">100%</strong> van de kosten tot &euro;40.000 vergoed.
                    </checkmark-item>
                    <checkmark-item class="mb-2" icon="info-circle-fill">
                      Daarnaast kunnen zij een tegemoetkoming van &euro;1.000 voor afwerkingskosten ontvangen.
                    </checkmark-item>
                    <checkmark-item class="mb-2" icon="info-circle-fill">
                      Huishoudens met een inkomen <strong class="fw-600">boven 140% van het sociaal minimum</strong> krijgen <strong class="fw-600">50%</strong> van de kosten tot &euro;40.000 vergoed.
                    </checkmark-item>
                  </div>
                  <div v-if="lead.property.InVersterkingsprogramma">
                    <checkmark-item class="mb-2" icon="patch-exclamation-fill text-info">
                        U heeft aangegeven dat uw woning in het versterkingsprogramma zit.
                        <router-link :to="{ name: 'formProperty' }" class="text-info fw-500 ms-2">
                          <i class="bi bi-pencil-fill me-1"></i>Aanpassen
                        </router-link>
                    </checkmark-item>
                    <checkmark-item class="mb-2" icon="info-circle-fill">
                      Huishoudens <strong class="fw-600">in het versterkingsgebied</strong> &eacute;n <strong class="fw-600">woningen</strong> daarbuiten die <strong class="fw-600">in het versterkingsprogramma van de NCG</strong> zitten, krijgen <strong class="fw-600">100%</strong> van de kosten tot &euro;40.000 vergoed.
                    </checkmark-item>
                    <checkmark-item class="mb-2" icon="info-circle-fill">
                      Daarnaast kunnen huishoudens met een inkomen <strong class="fw-600">tot 140% van het sociaal minimum</strong> een tegemoetkoming van &euro;1.000 voor afwerkingskosten ontvangen.
                    </checkmark-item>
                  </div>
                  <!-- <checkmark-item class="mb-2" icon="info-circle-fill">
                    Met deze vragen maken wij een inschatting of uw inkomen binnen de grenzen valt.
                  </checkmark-item> -->
                  <checkmark-item class="mb-2" icon="people-fill">
                    Hierbij wordt het inkomen <strong class="fw-600">per huishouden</strong> gehanteerd.
                  </checkmark-item>
              </div>
            </div>
            
            <base-input
                class="mb-4 mt-2"
                type="radiobuttons"
                :options="yesNoDontKnow"
                name="TooHighIncomeShortcut"
                v-model:value="lead.financing.income.TooHighIncomeShortcut"
              >
                Ik verdien meer dan het sociaal minimum
              </base-input>

            <!-- <base-input
              class="mt-5"
              type="radiobuttons" :options="yesNoDontKnow"
              name="ReceivedEnergySupport"
              v-model:value="lead.financing.income.ReceivedEnergySupport" :validator="v$.financing.income.ReceivedEnergySupport">
              Heeft u energietoeslag ontvangen?
            </base-input> -->

            <base-card inner-class="py-2 bg-transparent" v-show="showIncomeFollowup" class="mt-5">
              <base-input
                type="radiobuttons" :options="civilStatusOptions"
                name="Consent"
                v-model:value="lead.financing.income.CivilStatus" :validator="v$.financing.income.CivilStatus">
                Bent u alleenstaand of gehuwd?
              </base-input>

              <!-- <base-input
                type="radiobuttons" :options="ageBrackets" text-align="left" direction="column"
                name="Consent"
                v-model:value="lead.financing.income.AgeBracket" :validator="v$.financing.income.AgeBracket">
                In welke leeftijdsgroep valt u?
              </base-input>
              
              <transition name="fade-in-up">
                <base-input
                  v-if="lead.financing.income.CivilStatus === 'Gehuwd of samenwonend'"
                  type="radiobuttons" :options="ageBrackets" text-align="left" direction="column"
                  name="Consent"
                  v-model:value="lead.financing.income.AgeBracketPartner" :validator="v$.financing.income.AgeBracketPartner">
                  In welke leeftijdsgroep valt uw partner?
                </base-input>
              </transition>

              <base-input
                type="radiobuttons" :options="yesNo"
                name="Consent"
                v-model:value="lead.financing.income.HasChildren" :validator="v$.financing.income.HasChildren">
                Heeft u thuiswonende kinderen?
              </base-input> -->
            </base-card>

            <base-card class="mt-5" v-show="showIncomeInfoCard && showIncomeFollowup">
              <checkmark-item class="mb-4 fs-0-8em" icon="check-circle-fill" icon-color="success">
                Er is extra steun beschikbaar voor huishoudens met een inkomen tot <strong class="fw-600">140% van sociaal minimum</strong>.
              </checkmark-item>
              <strong class="fw-500">
                Extra subsidie bij een inkomen ({{ parseInt(new Date().getFullYear()) - 1 }}) tot:
              </strong>
              <div class="mb-4 fw-500">
                <span class="fw-600 fs-5 text-info">
                  {{ formatted_m29_SM140_amount }}
                </span>
              </div>
              
              <div class="fs-0-8em mt-2">
                <checkmark-item class="mb-2" icon="info-circle-fill" icon-color="secondary">
                  Het gaat om uw inkomen zoals vermeld op de <strong class="fw-600">inkomensverklaring van de Belastingdienst</strong>.
                </checkmark-item>
                <checkmark-item class="mb-2" icon="info-circle-fill" icon-color="secondary">
                  Ga naar <a href="https://www.belastingdienst.nl/wps/wcm/connect/nl/werk-en-inkomen/content/hoe-kom-ik-aan-een-inkomensverklaring" target="_blank">belastingdienst.nl/.../hoe-kom-ik-aan-een-inkomensverklaring</a> om uw inkomensverklaring te downloaden.
                </checkmark-item>
                <checkmark-item class="mb-2" icon="info-circle-fill" icon-color="secondary">
                  Dit heet het <strong class="fw-600">verzamelinkomen</strong> in uw aangifte/aanslag.
                </checkmark-item>
                <checkmark-item class="mb-2" icon="info-circle-fill" icon-color="secondary">
                  <span v-if="lead.financing.income.CivilStatus === 'Gehuwd of samenwonend'">
                    U geeft aan dat u een partner heeft. <strong class="fw-600">Tel de inkomens van u en uw partner bij elkaar op.</strong>
                  </span>
                  <span v-else>
                    Heeft u een partner? Tel dan de inkomens uit beide inkomensverklaringen bij elkaar op.
                  </span>
                </checkmark-item>
              </div>
            </base-card>


            <base-input
              v-if="lead.m29_SM140_amount && showIncomeFollowup"
              class="mt-3"
              type="radiobuttons" :options="moreLessInverted"
              name="SM_140pct"
              v-model:value="lead.financing.income.SM_140pct" :validator="v$.financing.income.SM_140pct">
              Was uw inkomen in {{ parseInt(new Date().getFullYear()) - 1 }} hoger of lager dan <strong class="fw-600">{{ formatted_m29_SM140_amount }}</strong>?
            </base-input>

            <base-input
              v-if="lead.financing.income.SM_140pct === false && showIncomeFollowup"
              class="mt-3"
              type="radiobuttons"
              :options="yesNo"
              name="ExpectLowerIncomeThisYear"
              v-model:value="lead.financing.income.ExpectLowerIncomeThisYear"
            >
              Verwacht u dit jaar minder inkomen en toch voor 140% in aanmerking te komen?
            </base-input>

          </base-form>
        <!-- form card end -->
        </base-card>
      
      <!-- cards wrapper end -->
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="shouldDisableNext">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  // import VariablePill from "@/components/VariablePill.vue"
  import CheckmarkItem from "@/components/CheckmarkItem.vue"
  // import IssueFeedback from "@/components/IssueFeedback.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"
  import { civilStatusOptions, ageBrackets } from "@/services/SocialMinimumService"
  import { minimumMonthlyNettWages } from "@/helpers/MinimumWage"
    
  import { LeadDataService } from "@/services/LeadDataService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      // VariablePill,
      CheckmarkItem,
      // IssueFeedback
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        showIncomeShortcut: true,
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        yesNoDontKnow: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee / Weet ik niet',
            value: false
          },
        ],
        moreLessInverted: [
          {
            label: '- Lager',
            value: true
          },
          {
            label: 'Hoger +',
            value: false
          },
        ],
        incomePeriods: [
          {
            label: 'jaar',
            value: 'jaar'
          },
          {
            label: 'maand',
            value: 'maand'
          },
        ],
        civilStatusOptions: civilStatusOptions,
        ageBrackets: ageBrackets
      };
    },
    mounted() {
      this.lead.markViewAsVisited(this.$route.name);
    },
    computed: {
      formatted_m29_SM140_amount() {
        return new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0
        }).format(this.lead.m29_SM140_amount);
      },
      showIncomeQuestions() {
        return true;
      },
      showIncomeInfoCard() {
        return this.showIncomeQuestions && this.lead.m29_SM140_amount;
      },
      incomeInvalid() {
        return this.showIncomeQuestions && this.incomeStore.nettIncome < 1;
      },
      showHouseholdQuestions() {
        return true;
      },
      showIncomeCategories() {
        return true;
      },
      hasAdviesAccess() {
        return FlowService.getAllowedSection(this.$route.query.section) === 'advies';
      },
      isInIntakeSection() {
        const viewKey = FlowService.getViewKeyFromName(this.$route.name);
        if (viewKey === null) return false;
        const view = FlowService.sequence[viewKey];
        return view.section === 'intake';
      },
      shouldDisableNext() {
        if (this.hasAdviesAccess && this.isInIntakeSection) {
          return false;
        }
        if (this.lead.financing.income.TooHighIncomeShortcut === true) {
          return false;
        }
        return this.v$.financing.income.$invalid;
      },
      showIncomeFollowup() {
        const v = this.lead.financing.income.TooHighIncomeShortcut;
        return v !== true && v !== undefined && v !== null;
      },
    },
    methods: {
      touchAndValidate() {
        if (this.hasAdviesAccess && this.isInIntakeSection) {
          return true;
        }
        this.v$.financing.income.$touch();
        return !this.v$.financing.income.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      },

      pushToLeadStore() {
        if (!this.incomeStore.nettIncome && !this.lead.financing.income.ReceivedEnergySupport) {
          return; // don't save if no income or ReceivedEnergySupport is entered
        }
        this.lead.financing.income.CalculatedSocialMinimum = this.socialMinimum;
        this.lead.financing.income.AppliedNettMinimumWages = minimumMonthlyNettWages['2025'].h1;
        this.lead.financing.income.SM_100pct = this.SM_100pct;
        this.lead.financing.income.SM_110pct = this.SM_110pct;
        this.lead.financing.income.SM_125pct = this.SM_125pct;
        this.lead.financing.income.SM_140pct = this.SM_140pct;
        this.lead.financing.income.WML_100pct = this.WML_100pct;
        this.lead.financing.income.WML_125pct = this.WML_125pct;
        this.lead.financing.income.WML_140pct = this.WML_140pct;
        this.lead.financing.income.over_WML_140pct = this.over_WML_140pct;
      }
    },
    watch: {
      socialMinimum() {
        this.pushToLeadStore();
      },
      'lead.financing.income.ReceivedEnergySupport'() {
        this.pushToLeadStore();
      },
      'incomeStore.nettIncome'() {
        this.pushToLeadStore();
      },
      'lead.financing.income.TooHighIncomeShortcut'(val) {
        if (val === true) {
          this.lead.financing.income.SM_140pct = false;
          this.lead.financing.income.SM_160pct = null;
          this.lead.financing.income.SM_180pct = null;
        }
      },
      'lead.financing.income.SM_140pct'(val) {
        if (val === true) {
          this.lead.financing.income.ExpectLowerIncomeThisYear = null;
        }
      },
      showHouseholdQuestions() {
        return true;
      },
    },
    beforeRouteLeave() {
      LeadDataService.pushRemoteData(this.uiStore.uuid, true);
    }
  }
</script>

<style lang="scss">
</style>
